import { render } from "./ContactImpactDialog.vue?vue&type=template&id=3bd6551e&scoped=true"
import script from "./ContactImpactDialog.vue?vue&type=script&lang=js"
export * from "./ContactImpactDialog.vue?vue&type=script&lang=js"

import "./ContactImpactDialog.vue?vue&type=style&index=0&id=3bd6551e&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd6551e"]])

export default __exports__